import { forEach } from 'lodash';

export function parseModelErrors(errors) {
    const parsedErrors = {};
    forEach(errors, e => {
        parsedErrors[e.param] = e.msg;
    });
    return parsedErrors;
}



// WEBPACK FOOTER //
// ./src/lib/error.utils.js